var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRapid7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 48,
    viewBox: "0 0 46 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1324 14.2945C26.9817 14.2945 15.3196 14.2945 12.5943 14.2945C12.8305 14.5312 13.0606 14.7745 13.2764 15.0316C15.0184 17.1069 15.9388 19.7202 15.9388 22.5889C15.9388 27.0163 14.0417 31.0118 11 33.7068H20.5169L25.0334 22.6427H19.3691L20.3189 18.3508H31.5544L25.6526 33.7068C25.6526 33.7068 26.4221 33.7068 27.961 33.7068C33.3551 33.7408 37 29.3357 37 23.9841C37 18.6328 33.5265 14.2945 28.1324 14.2945Z",
    fill: "#E84C1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRapid7);
export default __webpack_public_path__ + "static/media/Rapid7.01a5b4228535c8208bf034b5286c8f38.svg";
export { ForwardRef as ReactComponent };